/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');


var productSyncInterval, productSyncShopInterval;


$(document).ready(function() {

    // Check afterbuy connection
    //checkABDatas
    $('#checkABDatas').on('click', function() {
        myAccountId = $('#accountId').val();
        serializedDatas = $(this).closest('form').serialize();
        console.log(myAccountId);
        $.ajax({
            url: basePath+'/afterbuy/check/'+myAccountId,
            type: 'post',
            data: serializedDatas,
            dataType: 'json',
            success: function (response) {
                if (response.afterbuy == '0') {
                    $('#connectFailed span').text('afterbuy nicht erreichbar oder Zugang nicht korrekt.');
                    $('#connectFailed').show(function() {
                        setTimeout(function() {
                            $('#connectFailed').hide();
                            $('#connectFailed span').text('');
                        }, 4000);
                    });
                    $('#connectSuccess').hide();
                } else {
                    $('#connectSuccess').show(function() {
                        setTimeout(function() {
                            $('#connectSuccess').hide();
                        }, 2000);
                    });
                    $('#connectFailed').hide();
                }
            }
        });
    });

    // Check pixi connection
    $('#checkDatas').on('click', function() {
        serializedDatas = $(this).closest('form').serialize();
        $.ajax({
            url: basePath+'/pixi/check',
            type: 'post',
            data: serializedDatas,
            dataType: 'json',
            success: function (response) {
                if (response.pixie == '0') {
                    $('#connectFailed span').text('pixi nicht erreichbar oder Zugang nicht korrekt.');
                    $('#connectFailed').show(function() {
                        setTimeout(function() {
                            $('#connectFailed').hide();
                            $('#connectFailed span').text('');
                        }, 4000);
                    });
                    $('#connectSuccess').hide();
                } else {
                    $('#connectSuccess').show(function() {
                        setTimeout(function() {
                            $('#connectSuccess').hide();
                        }, 2000);
                    });
                    $('#connectFailed').hide();
                }
            }
        });
    });

    // ADMIN
    // #################################################################################################################

    // AddShop2Account
    $('#addShop2Customer').on('click', function() {
        serializedDatas = $(this).closest('form').serialize();
        $.ajax({
            url: basePath+'/settings/accounts/addShop',
            type: 'post',
            data: serializedDatas,
            dataType: 'json',
            success: function (response) {
                if (response.result == '0') {
                    //$('#addingFailed span').text('pixi nicht erreichbar Zugang nicht korrekt.');
                    $('#addingFailed').show(function() {
                        setTimeout(function() {
                            $('#addingFailed').hide();
                        }, 4000);
                    });
                } else {
                    location.reload();
                }
            }
        });
    });

    if ($('.valPlattform').length > 1) {
        $('.valPlattform').click(function() {
            $('.valPlattform').prop('checked', false);
            $("#captureImage").removeAttr('checked');
            $(this).prop('checked', true);
            $(this).attr('checked','checked');
        });
    }

    if ($('#platform').length == 1 && $('#platformtype').length == 1) {
        $('#platform').change(function() {
            if ($(this).val() == 'ebay') {
                $('#platformtype').closest('.col-6').removeClass('hidden');
            } else if($(this).val() == 'amazon') {
                $('#platformtype').closest('.col-6').removeClass('hidden');
            } else {
                $('#platformtype').closest('.col-6').addClass('hidden');
            }
        })
    }

    // UpdateShop2Account
    $('.updateShop2Customer').on('click', function() {
        token               = $(this).closest('form').children('input[name=_token]').val();
        updatePlattform     = $(this).closest('tr').children('td').children('input.valPlattform');
        updatePrefix        = $(this).closest('tr').children('td').children('input.valPrefix');

        if(updatePlattform[0].checked) {
            updatePlattform = 'default';
        } else {
            updatePlattform = '';
        }

        updateDatas         = updatePrefix[0];
        updatePrefixes      = updatePrefix[0];
        shopId              = $(updateDatas).attr('data-shop');
        updateValue         = $(updateDatas).val();
        updateOrderPrefix   = $(updatePrefixes).val();
        accountId           = $('#accountId').val();

        $.ajax({
            url: basePath+'/settings/accounts/updateShop',
            type: 'post',
            data: 'accountId='+accountId+'&shopId='+shopId+'&updateVal='+updateValue+'&prefix='+updateOrderPrefix+'&abPlattform='+updatePlattform+'&_token='+token,
            dataType: 'json',
            success: function (response) {
                if (response.result == '0') {
                    //$('#addingFailed span').text('pixi nicht erreichbar Zugang nicht korrekt.');
                    failureLine = $(this).closest('tr');
                    $(failureLine).addClass('table-danger').delay(4000).removeClass('table-danger');
                } else {
                    location.reload();
                }
            }
        });

    });

    // deleteShop2Customer
    $('.deleteShop2Customer').on('click', function() {
        token           = $(this).closest('form').children('input[name=_token]').val();
        updatePlattform = $(this).closest('tr').children('td').children('input');
        updateDatas     = updatePlattform[0];
        shopId          = $(updateDatas).attr('data-shop');
        updateValue     = $(updateDatas).val();
        accountId       = $('#accountId').val();

        $.ajax({
            url: basePath+'/settings/accounts/deleteShop',
            type: 'post',
            data: 'accountId='+accountId+'&shopId='+shopId+'&updateVal='+updateValue+'&_token='+token,
            dataType: 'json',
            success: function (response) {
                if (response.result == '0') {
                    //$('#addingFailed span').text('pixi nicht erreichbar Zugang nicht korrekt.');
                    failureLine = $(this).closest('tr');
                    $(failureLine).addClass('table-danger').delay(4000).removeClass('table-danger');
                } else {
                    location.reload();
                }
            }
        });
    });

    // updateMatching Products
    $('.updateMatching').on('click', function() {
        mappingId       = $(this).closest('tr').data('id');
        token           = $('#productMatchingNew').children('input[name=_token]').val();

        sorting         = $(this).closest('tr').children('td').children('.sort').val();
        abKey           = $(this).closest('tr').children('td').children('.abKey').val();
        pixiKey         = $(this).closest('tr').children('td').children('.pixiKey').val();
        failureLine     = $(this).closest('tr');
        $.ajax({
            url: basePath+'/admin/productkeymatching/update',
            type: 'post',
            data: 'mappingId='+mappingId+'&sorting='+sorting+'&abKey='+abKey+'&pixiKey='+pixiKey+'&_token='+token,
            dataType: 'json',
            success: function (response) {
                if (response.result == '0') {
                    $(failureLine).addClass('table-danger');
                    setTimeout(function () {
                        $(failureLine).removeClass('table-danger');
                    }, 4000);
                } else {
                    $(failureLine).addClass('table-success');
                    setTimeout(function () {
                        $(failureLine).removeClass('table-success');
                    }, 4000);
                }
            }
        });
    });

    // delete mapping
    $('.deleteMatching').on('click', function() {
        mappingId = $(this).closest('tr').data('id');
        token = $('#productMatchingNew').children('input[name=_token]').val();

        $.ajax({
            url: basePath+'/admin/productkeymatching/delete',
            type: 'post',
            data: 'mappingId='+mappingId+'&_token='+token,
            dataType: 'json',
            success: function (response) {
                if (response.result == '0') {
                    //$('#addingFailed span').text('pixi nicht erreichbar Zugang nicht korrekt.');
                    failureLine = $(this).closest('tr');
                    $(failureLine).addClass('table-danger').delay(4000).removeClass('table-danger');
                } else {
                    location.reload();
                }
            }
        });
    });


    // Customer
    // #################################################################################################################

    // ---------------------------------------------------- COUNTRYS ---------------------------------------------------
    // updateMapping Countrys
    $('.updateMapping').on('click', function() {
        mappingId       = $(this).closest('tr').data('id');
        userid          = $(this).closest('tr').data('userid');
        console.log(userid);
        token           = $('#countryMappingNew').children('input[name=_token]').val();

        abCountryIso    = $(this).closest('tr').children('td').children('input.abCountryIso');
        pxCountry       = $(this).closest('tr').children('td').children('input.pxCountry');
        oAbCountryIso   = abCountryIso[0];
        oPxCountry      = pxCountry[0];
        sAbCountryIso   = $(oAbCountryIso).val();
        sPxCountry      = $(oPxCountry).val();
        failureLine     = $(this).closest('tr');

        $.ajax({
            url: basePath+'/countrymapping/update',
            type: 'post',
            data: 'abCountryIso='+sAbCountryIso+'&pxCountry='+sPxCountry+'&mappingId='+mappingId+'&userid='+userid+'&_token='+token,
            dataType: 'json',
            success: function (response) {
                if (response.result == '0') {
                    $(failureLine).addClass('table-danger');
                    setTimeout(function () {
                        $(failureLine).removeClass('table-danger');
                    }, 4000);
                } else {
                    $(failureLine).addClass('table-success');
                    setTimeout(function () {
                        $(failureLine).removeClass('table-success');
                    }, 4000);
                }
            }
        });
    });

    // delete mapping
    $('.deleteMapping').on('click', function() {
        mappingId = $(this).closest('tr').data('id');
        shopId = $(this).closest('tr').data('shopid');
        token = $('#countryMappingNew').children('input[name=_token]').val();

        $.ajax({
            url: basePath+'/countrymapping/delete',
            type: 'post',
            data: 'mappingId='+mappingId+'&shopid='+shopId+'&_token='+token,
            dataType: 'json',
            success: function (response) {
                if (response.result == '0') {
                    failureLine = $(this).closest('tr');
                    $(failureLine).addClass('table-danger').delay(4000).removeClass('table-danger');
                } else {
                    location.reload();
                }
            }
        });
    });

    $('.deleteArticleIdMapping').on('click', function() {
        mappingId = $(this).closest('tr').data('id');
        shopId = $(this).closest('tr').data('shopid');
        token = $('#articleIdMappingNew').children('input[name=_token]').val();

        $.ajax({
            url: basePath+'/articlemapping/delete',
            type: 'post',
            data: 'mappingId='+mappingId+'&shopid='+shopId+'&_token='+token,
            dataType: 'json',
            success: function (response) {
                if (response.result == '0') {
                    failureLine = $(this).closest('tr');
                    $(failureLine).addClass('table-danger').delay(4000).removeClass('table-danger');
                } else {
                    location.reload();
                }
            }
        });
    });



    // ---------------------------------------------------- PAYMENTS ---------------------------------------------------
    // updateMapping Payments
    $('.updatePaymentMapping').on('click', function() {
        mappingId       = $(this).closest('tr').data('id');
        userid          = $(this).closest('tr').data('userid');
        console.log(userid);
        token           = $('#paymentMappingNew').children('input[name=_token]').val();

        abPayment               = $(this).closest('tr').children('td').children('input.abPayment');
        pxPayment               = $(this).closest('tr').children('td').children('input.pxPayment');
        abPaymentProcessing     = $(this).closest('tr').children('td').children('input.abPaymentProcessing');
        abTransmitTransactionId = 0;
        if ($(this).closest('tr').children('td').children('input.abTransmitTransactionId').is(':checked')) {
            abTransmitTransactionId = 1;
        }

        oAbPayment              = abPayment[0];
        oPxPayment              = pxPayment[0];
        oAbPaymentProcessing    = abPaymentProcessing[0];


        sAbPayment              = $(oAbPayment).val();
        sPxPayment              = $(oPxPayment).val();
        sAbPaymentProcessing    = $(oAbPaymentProcessing).val();
        failureLine     = $(this).closest('tr');
        console.log('abPayment='+sAbPayment+'&pxPayment='+sPxPayment+'&abPaymentProcessing='+sAbPaymentProcessing+'&transfer='+abTransmitTransactionId+'&mappingId='+mappingId+'&_token='+token);
        $.ajax({
            url: basePath+'/paymentmapping/update',
            type: 'post',
            data: 'abPayment='+sAbPayment+'&pxPayment='+sPxPayment+'&abPaymentProcessing='+sAbPaymentProcessing+'&transfer='+abTransmitTransactionId+'&mappingId='+mappingId+'&_token='+token,
            dataType: 'json',
            success: function (response) {
                if (response.result == '0') {
                    $(failureLine).addClass('table-danger');
                    setTimeout(function () {
                        $(failureLine).removeClass('table-danger');
                    }, 4000);
                } else {
                    $(failureLine).addClass('table-success');
                    setTimeout(function () {
                        $(failureLine).removeClass('table-success');
                    }, 4000);
                }
            }
        });
    });

    // delete mapping
    $('.deletePaymentMapping').on('click', function() {
        mappingId = $(this).closest('tr').data('id');
        shopId = $(this).closest('tr').data('shopid');
        token = $('#paymentMappingNew').children('input[name=_token]').val();
        console.log('mappingId='+mappingId+'&shopId='+shopId+'&_token='+token);

        $.ajax({
            url: basePath+'/paymentmapping/delete',
            type: 'post',
            data: 'mappingId='+mappingId+'&shopId='+shopId+'&_token='+token,
            dataType: 'json',
            success: function (response) {
                if (response.result == '0') {
                    //$('#addingFailed span').text('pixi nicht erreichbar Zugang nicht korrekt.');
                    failureLine = $(this).closest('tr');
                    $(failureLine).addClass('table-danger').delay(4000).removeClass('table-danger');
                } else {
                    location.reload();
                }
            }
        });
    });

    // ---------------------------------------------------- SHIPPING ---------------------------------------------------
    // updateMapping Shipping
    $('.updateShippingMapping').on('click', function() {
        mappingId       = $(this).closest('tr').data('id');
        userid          = $(this).closest('tr').data('userid');
        token           = $('#shippingMappingNew').children('input[name=_token]').val();

        abShipping              = $(this).closest('tr').children('td').children('input.abShipping');
        pxShipping              = $(this).closest('tr').children('td').children('input.pxShipping');
        pxShippingRemark        = $(this).closest('tr').children('td').children('input.pxShippingRemark');

        pxForce = 0;
        if ($(this).closest('tr').children('td').children('input.force').is(':checked')) {
            pxForce = 1;
        }

        pxNoTracking = 0;
        if ($(this).closest('tr').children('td').children('input.notracking').is(':checked')) {
            pxNoTracking = 1;
        }


        oAbShipping             = abShipping[0];
        oPxShipping             = pxShipping[0];
        oPxShippingRemark       = pxShippingRemark[0];

        sAbShipping              = $(oAbShipping).val();
        sPxShipping              = $(oPxShipping).val();
        sPxShippingRemark        = $(oPxShippingRemark).val();
        failureLine     = $(this).closest('tr');

        $.ajax({
            url: basePath+'/shippingmapping/update',
            type: 'post',
            data: 'abShipping='+sAbShipping+'&pxShipping='+sPxShipping+'&pxShippingRemark='+sPxShippingRemark+'&mappingId='+mappingId+'&userid='+userid+'&force='+pxForce+'&notracking='+pxNoTracking+'&_token='+token,
            dataType: 'json',
            success: function (response) {
                if (response.result == '0') {
                    $(failureLine).addClass('table-danger');
                    setTimeout(function () {
                        $(failureLine).removeClass('table-danger');
                    }, 4000);
                } else {
                    $(failureLine).addClass('table-success');
                    setTimeout(function () {
                        $(failureLine).removeClass('table-success');
                    }, 4000);
                }
            }
        });
    });

    // ---------------------------------------------------- ArticleId ---------------------------------------------------
    // updateMapping Shipping
    $('.updateArticleIdMapping').on('click', function() {
        mappingId       = $(this).closest('tr').data('id');
        userid          = $(this).closest('tr').data('userid');
        token           = $('#articleIdMappingNew').children('input[name=_token]').val();

        abArticle              = $(this).closest('tr').children('td').children('input.abArticle').val();
        pxArticle              = $(this).closest('tr').children('td').children('input.pxArticle').val();
        failureLine     = $(this).closest('tr');

        $.ajax({
            url: basePath+'/articlemapping/update',
            type: 'post',
            data: 'abArticle='+abArticle+'&pxArticle='+pxArticle+'&mappingId='+mappingId+'&_token='+token,
            dataType: 'json',
            success: function (response) {
                if (response.result == '0') {
                    $(failureLine).addClass('table-danger');
                    setTimeout(function () {
                        $(failureLine).removeClass('table-danger');
                    }, 4000);
                } else {
                    $(failureLine).addClass('table-success');
                    setTimeout(function () {
                        $(failureLine).removeClass('table-success');
                    }, 4000);
                }
            }
        });
    });

    // Resync Article ID Mapping - mark for re-sync
    $('.resyncArticleIdMapping').on('click', function() {
        mappingId = $(this).closest('tr').data('id');
        token = $('#articleIdMappingNew').children('input[name=_token]').val();
        failureLine = $(this).closest('tr');

        $.ajax({
            url: basePath+'/articlemapping/resync',
            type: 'post',
            data: 'mappingId='+mappingId+'&_token='+token,
            dataType: 'json',
            success: function (response) {
                if (response.result == '0') {
                    $(failureLine).addClass('table-danger');
                    setTimeout(function () {
                        $(failureLine).removeClass('table-danger');
                    }, 4000);
                } else {
                    location.reload(); // Reload to show updated resync badge
                }
            }
        });
    });

    $('.updateShippingMappingUpdate').on('click', function() {
        mappingId       = $(this).closest('tr').data('id');
        userid          = $(this).closest('tr').data('userid');
        token           = $('#shippingMappingNew').children('input[name=_token]').val();

        abShipping              = $(this).closest('tr').children('td').children('input.abShipping');
        pxShipping              = $(this).closest('tr').children('td').children('input.pxShipping');

        oAbShipping             = abShipping[0];
        oPxShipping             = pxShipping[0];

        sAbShipping              = $(oAbShipping).val();
        sPxShipping              = $(oPxShipping).val();
        failureLine     = $(this).closest('tr');

        $.ajax({
            url: basePath+'/shippingmappingUpdate/update',
            type: 'post',
            data: 'abShipping='+sAbShipping+'&pxShipping='+sPxShipping+'&mappingId='+mappingId+'&userid='+userid+'&_token='+token,
            dataType: 'json',
            success: function (response) {
                if (response.result == '0') {
                    $(failureLine).addClass('table-danger');
                    setTimeout(function () {
                        $(failureLine).removeClass('table-danger');
                    }, 4000);
                } else {
                    $(failureLine).addClass('table-success');
                    setTimeout(function () {
                        $(failureLine).removeClass('table-success');
                    }, 4000);
                }
            }
        });
    });

    // delete mapping
    $('.deleteShippingMapping').on('click', function() {
        mappingId = $(this).closest('tr').data('id');
        shopId = $(this).closest('tr').data('shopid');
        token = $('#shippingMappingNew').children('input[name=_token]').val();

        $.ajax({
            url: basePath+'/shippingmapping/delete',
            type: 'post',
            data: 'mappingId='+mappingId+'&shopid='+shopId+'&_token='+token,
            dataType: 'json',
            success: function (response) {
                if (response.result == '0') {
                    //$('#addingFailed span').text('pixi nicht erreichbar Zugang nicht korrekt.');
                    failureLine = $(this).closest('tr');
                    $(failureLine).addClass('table-danger').delay(4000).removeClass('table-danger');
                } else {
                    location.reload();
                }
            }
        });
    });

    $('.deleteShippingMappingUpdate').on('click', function() {
        mappingId = $(this).closest('tr').data('id');
        shopId = $(this).closest('tr').data('shopid');
        token = $('#shippingMappingNew').children('input[name=_token]').val();

        $.ajax({
            url: basePath+'/shippingmappingUpdate/delete',
            type: 'post',
            data: 'mappingId='+mappingId+'&shopid='+shopId+'&_token='+token,
            dataType: 'json',
            success: function (response) {
                if (response.result == '0') {
                    //$('#addingFailed span').text('pixi nicht erreichbar Zugang nicht korrekt.');
                    failureLine = $(this).closest('tr');
                    $(failureLine).addClass('table-danger').delay(4000).removeClass('table-danger');
                } else {
                    location.reload();
                }
            }
        });
    });

    // ---------------------------------------------------- Artikel Tags ---------------------------------------------------
    // update Shippingmapping
    $('.updateTagShipping').on('click', function() {
        mappingId       = $(this).closest('tr').data('id');
        token           = $('#shippingMappingNew').children('input[name=_token]').val();

        tag              = $(this).closest('tr').children('td').children('input.tag');
        pxShipping       = $(this).closest('tr').children('td').children('input.pxShipping');
        country          = $(this).closest('tr').children('td').children('input.country');
        oAbShipping      = tag[0];
        oPxShipping      = pxShipping[0];

        sAbShipping      = $(tag).val();
        sPxShipping      = $(oPxShipping).val();
        sCountry         = $(country).val();
        failureLine      = $(this).closest('tr');

        $.ajax({
            url: basePath+'/tagshipping/update',
            type: 'post',
            data: 'tag='+sAbShipping+'&pxShipping='+sPxShipping+'&mappingId='+mappingId+'&country='+sCountry+'&_token='+token,
            dataType: 'json',
            success: function (response) {
                if (response.result == '0') {
                    $(failureLine).addClass('table-danger');
                    setTimeout(function () {
                        $(failureLine).removeClass('table-danger');
                    }, 4000);
                } else {
                    $(failureLine).addClass('table-success');
                    setTimeout(function () {
                        $(failureLine).removeClass('table-success');
                    }, 4000);
                }
            }
        });
    });

    // delete mapping
    $('.deleteTagShipping').on('click', function() {
        mappingId = $(this).closest('tr').data('id');
        token = $('#shippingMappingNew').children('input[name=_token]').val();

        $.ajax({
            url: basePath+'/tagshipping/delete',
            type: 'post',
            data: 'mappingId='+mappingId+'&_token='+token,
            dataType: 'json',
            success: function (response) {
                if (response.result == '0') {
                    //$('#addingFailed span').text('pixi nicht erreichbar Zugang nicht korrekt.');
                    failureLine = $(this).closest('tr');
                    $(failureLine).addClass('table-danger').delay(4000).removeClass('table-danger');
                } else {
                    location.reload();
                }
            }
        });
    });


    $('#userEdit').submit(function (e) {
       var form = this;
       e.preventDefault();
       if ($('#password').val() == $('#passwordrepeat').val()) {
           form.submit();
       } else {
           $('#passwordFailed').show(function() {
               setTimeout(function() {
                   $('#passwordFailed').hide();
               }, 4000);
           });
       }
    });

    var actDeleteLink = null;

    $('.deleteAccountButton').on('click', function(e){
        e.preventDefault();
        actDeleteLink = $(this).attr('href');
        $('#deleteAccountRequest').modal("show");
    })

    $('#cancelDeleteLink').on('click', function() {
        actDeleteLink = null;
    });

    $('#confirmDeleteLink').on('click', function() {
        if (actDeleteLink != null) {
            window.location.href = actDeleteLink;
        } else {
            $('#cancelDeleteLink').click();
        }
    });

    $('#sendPixi_prd_2_afterbuy').on('click', function() {
        accountId = $('#accountIdSecond').val();
        serializedDatas = $(this).closest('form').serialize();
        $(this).prop("disabled",true);
        $(this).addClass('workin');
        $.ajax({
            url: basePath + '/admin/support/sendFromPixi2AB',
            type: 'post',
            data: serializedDatas,
            dataType: 'json',
            success: function (response) {
                if (response == 1) {
                    productSyncShopInterval = setInterval(function() {
                        $.ajax({
                            url: basePath + '/getProductShopSyncState',
                            type: 'get',
                            success: function (response) {
                                if (response == 1) {
                                    $('#sendPixi_prd_2_afterbuy').prop("disabled",false);
                                    $('#sendPixi_prd_2_afterbuy').removeClass('workin');
                                }
                            }, error: function (request, status, error) {
                                $('#sendPixi_prd_2_afterbuy').prop("disabled",false);
                                $('#sendPixi_prd_2_afterbuy').removeClass('workin');
                            }
                        });
                    }, 5000);
                }
            }, error: function (request, status, error) {
                $('#sendPixi_prd_2_afterbuy').prop("disabled",false);
                $('#sendPixi_prd_2_afterbuy').removeClass('workin');
            }
        });
    });

    $('#sendAB_prd_2_pixi').on('click', function() {
        accountId = $('#accountId').val();
        serializedDatas = $(this).closest('form').serialize();
        $(this).prop("disabled",true);
        $(this).addClass('workin');

        $.ajax({
            url: basePath+'/admin/support/sendFromAB2Pixi',
            type: 'post',
            data: serializedDatas,
            dataType: 'json',
            async: true,
            success: function (response) {
                console.log('Product sync completed:', response);
            },
            error: function (request, status, error) {
                console.log('Product sync error:', error);
            }
        });

        /* OLD LOGIC - Commented out (waits for response, causes browser hang on long syncs)
        $.ajax({
            url: basePath+'/admin/support/sendFromAB2Pixi',
            type: 'post',
            data: serializedDatas,
            dataType: 'json',
            success: function (response) {
                if (response == 1) {
                    productSyncInterval = setInterval(function() {
                        $.ajax({
                            url: basePath+'/getProductSyncPageState/'+accountId,
                            type: 'get',
                            async: false,
                            success: function(response) {
                                console.log('response:'+response);
                                if (response == 1) {
                                    clearInterval(productSyncInterval);
                                    $('#submitSuccessProduct').show(function() {
                                        setTimeout(function() {
                                            $('#submitSuccessProduct').hide();
                                            $('#sendAB_prd_2_pixi').prop("disabled",false);
                                            $('#sendAB_prd_2_pixi').removeClass('workin');
                                        }, 4000);
                                    });
                                }
                                //location.reload();
                            }, error: function (request, status, error) {
                                console.log('response:'+error);
                            }
                        });
                    },5000);

                } else {
                    $('#submitFailedProduct span').text(response);
                    $('#submitFailedProduct').show(function() {
                        setTimeout(function() {
                            $('#submitFailedProduct').hide();
                            $('#sendAB_prd_2_pixi').prop("disabled",false);
                            $('#sendAB_prd_2_pixi').removeClass('workin');
                            $('#submitFailedProduct span').text('');
                        }, 4000);
                    });
                }

            },
            error: function (request, status, error) {
                $('#submitFailedProduct').show(function() {
                    setTimeout(function() {
                        $('#submitFailedProduct').hide();
                    }, 4000);
                });
                $('#sendAB_prd_2_pixi').prop("disabled",false);
                $('#sendAB_prd_2_pixi').removeClass('workin');
            }
        });
        */
    });

    $('#sendAB_order_2_pixi').on('click', function() {
        serializedDatas = $(this).closest('form').serialize();
        $('#downloadLinks').fadeOut();
        $(this).prop("disabled",true);
        $(this).addClass('workin');

        $.ajax({
            url: basePath+'/admin/support/sendFromAb2PixiOrders',
            type: 'post',
            data: serializedDatas,
            dataType: 'json',
            success: function (response) {
                console.log(response.debug)
                console.log(response)

                if (response.result == 1) {
                    $('#submitSuccessOrder').show(function() {
                        setTimeout(function() {
                            $('#submitSuccessOrder').hide();
                        }, 4000);
                    });
                    if (response.debug == 1) {
                        $('#downloadLinks').text('');
                        $('#downloadLinks').append('<h6>Download debugging Dateien');
                        $('#downloadLinks').append('<a href="'+basePath+'/'+response.downloadLink1+'" target="_blank" download>Log File</a><br>');
                        $('#downloadLinks').append('<a href="'+basePath+'/'+response.downloadLink2+'" target="_blank" download>XML File</a>');
                        $('#downloadLinks').fadeIn();
                    }
                } else {
                    $('#submitFailedOrder').show(function() {
                        setTimeout(function() {
                            $('#submitFailedOrder').hide();
                        }, 4000);
                    });
                }
                $('#sendAB_order_2_pixi').prop("disabled",false);
                $('#sendAB_order_2_pixi').removeClass('workin');
            },
            error: function (request, status, error) {
                $('#submitFailedOrder').show(function() {
                    setTimeout(function() {
                        $('#submitFailedOrder').hide();
                    }, 4000);
                });
                $('#sendAB_order_2_pixi').prop("disabled",false);
                $('#sendAB_order_2_pixi').removeClass('workin');
            }
        });
    });

    $('#sendAB_single_order_2_pixi').on('click', function() {
        serializedDatas = $(this).closest('form').serialize() + '&countingOrders=1';
        $('#downloadLinks').fadeOut();
        $(this).prop("disabled",true);
        $(this).addClass('workin');

        $.ajax({
            url: basePath+'/admin/support/sendFromAb2PixiOrders',
            type: 'post',
            data: serializedDatas,
            dataType: 'json',
            success: function (response) {
                console.log(response.debug)
                console.log(response)

                if (response.result == 1) {
                    $('#submitSuccessOrder').show(function() {
                        setTimeout(function() {
                            $('#submitSuccessOrder').hide();
                        }, 4000);
                    });
                    if (response.debug == 1) {
                        $('#downloadLinks').text('');
                        $('#downloadLinks').append('<h6>Download debugging Dateien');
                        $('#downloadLinks').append('<a href="'+basePath+'/'+response.downloadLink1+'" target="_blank" download>Log File</a><br>');
                        $('#downloadLinks').append('<a href="'+basePath+'/'+response.downloadLink2+'" target="_blank" download>XML File</a>');
                        $('#downloadLinks').fadeIn();
                    }
                } else {
                    $('#submitFailedOrder').show(function() {
                        setTimeout(function() {
                            $('#submitFailedOrder').hide();
                        }, 4000);
                    });
                }
                $('#sendAB_single_order_2_pixi').prop("disabled",false);
                $('#sendAB_single_order_2_pixi').removeClass('workin');
            },
            error: function (request, status, error) {
                $('#submitFailedOrder').show(function() {
                    setTimeout(function() {
                        $('#submitFailedOrder').hide();
                    }, 4000);
                });
                $('#sendAB_single_order_2_pixi').prop("disabled",false);
                $('#sendAB_single_order_2_pixi').removeClass('workin');
            }
        });
    });

    $('#sendAB_single_prd_2_pixi').on('click', function() {
        serializedDatas = $(this).closest('form').serialize() + '&countingPrds=1';
        $(this).prop("disabled",true);
        $(this).addClass('workin');

        $.ajax({
            url: basePath+'/admin/support/sendFromAB2Pixi',
            type: 'post',
            data: serializedDatas,
            dataType: 'json',
            success: function (response) {
                console.log(response)

                if (response == 1) {
                    $('#submitSuccessProduct').show(function() {
                        setTimeout(function() {
                            $('#submitSuccessProduct').hide();
                        }, 4000);
                    });
                } else {
                    $('#submitFailedProduct span').text(response);
                    $('#submitFailedProduct').show(function() {
                        setTimeout(function() {
                            $('#submitFailedProduct').hide();
                        }, 4000);
                    });
                }
                $('#sendAB_single_prd_2_pixi').prop("disabled",false);
                $('#sendAB_single_prd_2_pixi').removeClass('workin');
            },
            error: function (request, status, error) {
                $('#submitFailedProduct').show(function() {
                    setTimeout(function() {
                        $('#submitFailedProduct').hide();
                    }, 4000);
                });
                $('#sendAB_single_prd_2_pixi').prop("disabled",false);
                $('#sendAB_single_prd_2_pixi').removeClass('workin');
            }
        });
    });

    $('#sendPixi_single_prd_2_afterbuy').on('click', function() {
        serializedDatas = $(this).closest('form').serialize() + '&countingPrds=1';
        $(this).prop("disabled",true);
        $(this).addClass('workin');

        $.ajax({
            url: basePath+'/admin/support/sendFromPixi2AB',
            type: 'post',
            data: serializedDatas,
            dataType: 'json',
            success: function (response) {
                console.log(response)

                if (response == 1) {
                    $('#submitSuccessProduct2AB').show(function() {
                        setTimeout(function() {
                            $('#submitSuccessProduct2AB').hide();
                        }, 4000);
                    });
                } else {
                    $('#submitFailedProduct2AB span').text(response);
                    $('#submitFailedProduct2AB').show(function() {
                        setTimeout(function() {
                            $('#submitFailedProduct2AB').hide();
                        }, 4000);
                    });
                }
                $('#sendPixi_single_prd_2_afterbuy').prop("disabled",false);
                $('#sendPixi_single_prd_2_afterbuy').removeClass('workin');
            },
            error: function (request, status, error) {
                $('#submitFailedProduct2AB').show(function() {
                    setTimeout(function() {
                        $('#submitFailedProduct2AB').hide();
                    }, 4000);
                });
                $('#sendPixi_single_prd_2_afterbuy').prop("disabled",false);
                $('#sendPixi_single_prd_2_afterbuy').removeClass('workin');
            }
        });
    });

    // Targeted single product stock test
    $('#testSingleStock').on('click', function() {
        itemNrInt = $('#testSingleStockItemNrInt').val();
        token = $('#adminProductSync2AB').children('input[name=_token]').val();

        if (!itemNrInt || itemNrInt == '') {
            alert('Bitte gib eine ItemNrInt/ProductID ein!');
            return;
        }

        $(this).prop("disabled",true);
        $(this).addClass('workin');

        $.ajax({
            url: basePath+'/admin/support/testSingleProductStock',
            type: 'post',
            data: 'itemNrInt='+itemNrInt+'&_token='+token,
            dataType: 'json',
            success: function (response) {
                if (response == '1') {
                    $('#submitSuccessProduct2AB span').text('Stock-Update für Produkt '+itemNrInt+' erfolgreich!');
                    $('#submitSuccessProduct2AB').show(function() {
                        setTimeout(function() {
                            $('#submitSuccessProduct2AB').hide();
                            $('#submitSuccessProduct2AB span').text('');
                        }, 3000);
                    });
                    $('#submitFailedProduct2AB').hide();
                } else {
                    $('#submitFailedProduct2AB span').text('Fehler: '+response);
                    $('#submitFailedProduct2AB').show(function() {
                        setTimeout(function() {
                            $('#submitFailedProduct2AB').hide();
                            $('#submitFailedProduct2AB span').text('');
                        }, 4000);
                    });
                    $('#submitSuccessProduct2AB').hide();
                }

                $('#testSingleStock').prop("disabled",false);
                $('#testSingleStock').removeClass('workin');
            },
            error: function () {
                $('#submitFailedProduct2AB span').text('Fehler beim Stock-Update');
                $('#submitFailedProduct2AB').show();
                $('#submitSuccessProduct2AB').hide();

                $('#testSingleStock').prop("disabled",false);
                $('#testSingleStock').removeClass('workin');
            }
        });
    });

    $('#sendAB_single_orderRetSto_2_pixi').on('click', function() {
        serializedDatas = $(this).closest('form').serialize() + '&count=1';
        $(this).prop("disabled",true);
        $(this).addClass('workin');

        $.ajax({
            url: basePath+'/admin/support/startAdminOrderRetState',
            type: 'post',
            data: serializedDatas,
            dataType: 'json',
            success: function (response) {
                console.log(response)

                if (response.result == 1) {
                    $('#submitRETSTOSuccessOrder').show(function() {
                        setTimeout(function() {
                            $('#submitRETSTOSuccessOrder').hide();
                        }, 4000);
                    });
                } else {
                    $('#submitRETSTOFailedOrder').show(function() {
                        setTimeout(function() {
                            $('#submitRETSTOFailedOrder').hide();
                        }, 4000);
                    });
                }
                $('#sendAB_single_orderRetSto_2_pixi').prop("disabled",false);
                $('#sendAB_single_orderRetSto_2_pixi').removeClass('workin');
            },
            error: function (request, status, error) {
                $('#submitRETSTOFailedOrder').show(function() {
                    setTimeout(function() {
                        $('#submitRETSTOFailedOrder').hide();
                    }, 4000);
                });
                $('#sendAB_single_orderRetSto_2_pixi').prop("disabled",false);
                $('#sendAB_single_orderRetSto_2_pixi').removeClass('workin');
            }
        });
    });

    $('#sendAB_orderRetSto_2_pixi').on('click', function() {
        serializedDatas = $(this).closest('form').serialize();
        //$('#downloadLinks').fadeOut();
        $(this).prop("disabled",true);
        $(this).addClass('workin');

        $.ajax({
            url: basePath+'/admin/support/startAdminOrderRetState',
            type: 'post',
            data: serializedDatas,
            dataType: 'json',
            success: function (response) {
                console.log(response)

                if (response.result == 1) {
                    $('#submitRETSTOSuccessOrder').show(function() {
                        setTimeout(function() {
                            $('#submitRETSTOSuccessOrder').hide();
                        }, 4000);
                    });
                } else {
                    $('#submitRETSTOFailedOrder').show(function() {
                        setTimeout(function() {
                            $('#submitRETSTOFailedOrder').hide();
                        }, 4000);
                    });
                }
                $('#sendAB_orderRetSto_2_pixi').prop("disabled",false);
                $('#sendAB_orderRetSto_2_pixi').removeClass('workin');
            },
            error: function (request, status, error) {
                $('#sendAB_orderRetSto_2_pixi').prop("disabled",false);
                $('#sendAB_orderRetSto_2_pixi').removeClass('workin');
            }
        });
    });

    $('#sendAB_order_2_pixi_extra').on('click', function() {
        serializedDatas = $(this).closest('form').serialize();
        $(this).prop("disabled",true);
        $(this).addClass('workin');

        $.ajax({
            url: basePath+'/admin/support/sendFromAb2PixiExtraOrdersSolo',
            type: 'post',
            data: serializedDatas,
            dataType: 'json',
            success: function (response) {
                if (response.result == 1) {
                    $('#submitSuccessOrderExtra').show(function() {
                        setTimeout(function() {
                            $('#submitSuccessOrderExtra').hide();
                        }, 4000);
                    });
                } else {
                    $('#submitFailedOrderExtra').show(function() {
                        setTimeout(function() {
                            $('#submitFailedOrderExtra').hide();
                        }, 4000);
                    });
                }
                $('#sendAB_order_2_pixi_extra').prop("disabled",false);
                $('#sendAB_order_2_pixi_extra').removeClass('workin');
            },
            error: function (request, status, error) {
                $('#submitFailedOrderExtra').show(function() {
                    setTimeout(function() {
                        $('#submitFailedOrderExtra').hide();
                    }, 4000);
                });
                $('#sendAB_order_2_pixi_extra').prop("disabled",false);
                $('#sendAB_order_2_pixi_extra').removeClass('workin');
            }
        });
    });
    $('#sendAB_order_2_pixi_byId').on('click', function() {
        serializedDatas = $(this).closest('form').serialize();
        $(this).prop("disabled",true);
        $(this).addClass('workin');

        $.ajax({
            url: basePath+'/admin/support/sendFromAb2PixiOrderById',
            type: 'post',
            data: serializedDatas,
            dataType: 'json',
            success: function (response) {
                if (response.result == 1) {
                    $('#submitSuccessOrderById').show(function() {
                        setTimeout(function() {
                            $('#submitSuccessOrderById').hide();
                        }, 4000);
                    });
                    if (response.debug == 1) {
                        $('#downloadLinksById').text('');
                        $('#downloadLinksById').append('<h6>Download debugging Dateien');
                       // $('#downloadLinksById').append('<a href="'+basePath+'/'+response.downloadLink1+'" target="_blank" download>Log File</a><br>');
                        $('#downloadLinksById').append('<a href="'+basePath+'/'+response.downloadLink2+'" target="_blank" download>XML File</a>');
                        $('#downloadLinksById').fadeIn();
                    }
                } else {
                    $('#submitFailedOrderById').show(function() {
                        setTimeout(function() {
                            $('#submitFailedOrderById').hide();
                        }, 4000);
                    });
                }
                $('#sendAB_order_2_pixi_byId').prop("disabled",false);
                $('#sendAB_order_2_pixi_byId').removeClass('workin');
            },
            error: function (request, status, error) {
                $('#submitFailedOrderById').show(function() {
                    setTimeout(function() {
                        $('#submitFailedOrderExtra').hide();
                    }, 4000);
                });
                $('#sendAB_order_2_pixi_byId').prop("disabled",false);
                $('#sendAB_order_2_pixi_byId').removeClass('workin');
            }
        });
    });
    $('#syncCatalogFromAb').on('click', function() {
        serializedDatas = $(this).closest('form').serialize();
        $(this).prop("disabled",true);
        $(this).addClass('workin');
        $.ajax({
            url: basePath+'/admin/support/syncCatalog',
            type: 'post',
            data: serializedDatas,
            dataType: 'json',
            success: function (response) {
                if (response == 1) {
                    $('#submitSuccessCatalog').show(function() {
                        setTimeout(function() {
                            $('#submitSuccessProduct').hide();
                        }, 4000);
                    });
                } else {
                    $('#submitFailedCatalog').show(function() {
                        setTimeout(function() {
                            $('#submitFailedProduct').hide();
                        }, 4000);
                    });
                }
                $('#syncCatalogFromAb').prop("disabled",false);
                $('#syncCatalogFromAb').removeClass('workin');
            },
            error: function (request, status, error) {
                $('#submitFailedProduct').show(function() {
                    setTimeout(function() {
                        $('#submitFailedProduct').hide();
                    }, 4000);
                });
                $('#syncCatalogFromAb').prop("disabled",false);
                $('#syncCatalogFromAb').removeClass('workin');
            }
        });
    });

    function simpleAjaxSave(formId) {
        serializedDatas = $('#'+formId).serialize();
        saveButton      = $('#'+formId).find('button');
        action          = $('#'+formId).attr('action');
        $(saveButton).prop("disabled",true);
        $(saveButton).addClass('workin');
        $.ajax({
            url: basePath+action,
            type: 'POST',
            data: serializedDatas,
            dataType: 'json',
            success: function (response) {
                if (response == 1) {
                    $('#'+formId).closest('.card').addClass('border').addClass('border-success').addClass('bg-success').addClass('text-white');
                    setTimeout(function () {
                        $('#'+formId).closest('.card').removeClass('border').removeClass('border-success').removeClass('bg-success').removeClass('text-white');
                    },2000);
                } else {
                    $('#'+formId).closest('.card').addClass('border').addClass('border-danger').addClass('bg-danger').addClass('text-white');
                    setTimeout(function () {
                        $('#'+formId).closest('.card').removeClass('border').removeClass('border-danger').removeClass('bg-danger').removeClass('text-white');
                    },2000);
                }

                $(saveButton).prop("disabled",false);
                $(saveButton).removeClass('workin');
            },
            error: function (request, status, error) {
                console.log(error);
                $('#'+formId).closest('.card').addClass('border').addClass('border-danger').addClass('bg-danger').addClass('text-white');
                setTimeout(function () {
                    $('#'+formId).closest('.card').removeClass('border').removeClass('border-danger').removeClass('bg-danger').removeClass('text-white');
                },2000);

                $(saveButton).prop("disabled",false);
                $(saveButton).removeClass('workin');
            }
        });
    }

    $('#tagSettings, #extraOrder, #orderStornoTag, #orderTrackingID, #filterSettings, #orderTestMode, #productTestMode, #productPX2ABTestMode, #orderPX2ABTestMode').submit(function (e) {
        saveName= $(this).attr('id');
       e.preventDefault();
        simpleAjaxSave(saveName);
    });

    if ($('#platform').length > 0) {
        showHidePlatform();
        $('#platform').on('change', function() {
            showHidePlatform();
        });
    }

    function showHidePlatform() {
        platformValue = $('#platform').val();
        if (
            platformValue != 'shop' &&
            platformValue != 'sellcreator' &&
            platformValue != 'ebay' &&
            platformValue != 'import' &&
            platformValue != 'va_modul' &&
            platformValue != 'va_provisionsabrechnung' &&
            platformValue != 'amazon' &&
            platformValue != 'yatego' &&
            platformValue != 'hood' &&
            platformValue != 'auvito' &&
            platformValue != 'echtwahr' &&
            platformValue != 'elimboelimbo' &&
            platformValue != 'ricardo' &&
            platformValue != 'default'
        ) {
            $('#ownPlatform').removeClass('hidden');
            $('#ownPlatform').attr('name','platform');
        } else {
            $('#ownPlatform').attr('name','platform_tmp');
            $('#ownPlatform').addClass('hidden');
        }
    }
});
